<template>
  <CSelector
    v-model="currentLang"
    :options="options"
    emit-value
    map-options
    :use-input="false"
    width="240px"
  />
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { changeLanguage } from '@/lib/changeLanguageFn';
import Cookies from 'js-cookie';

import CSelector from '@/components/uikit/CSelector';

const messages = {
  en: {
    Language: 'Language',
    'Updating...': 'Updating...',
  },
  ja: {
    Language: '言語',
    'Updating...': '更新中...',
  },
};

export default Vue.extend({
  name: 'MyAccountLanguage',
  i18n: { messages },
  components: { CSelector },
  created() {
    this.lang = this.$store.state.userState.settings.language;
  },
  data() {
    return {
      lang: 'ja',
      options: [
        {
          label: 'English',
          value: 'en',
        },
        {
          label: '日本語',
          value: 'ja',
        },
      ],
    };
  },
  computed: {
    currentLang: {
      set(value) {
        this.lang = value;
        this.changeLang(value);
      },
      get() {
        return this.lang;
      },
    },

    ...mapGetters('user', { isSSO: 'isSSO' }),
  },
  methods: {
    async changeLang(value) {
      try {
        // Log
        this.$alpha.logger.addBreadcrumb('Select Language.');

        // Start Request
        await this.$alpha.loading.show(this.$t('Updating...'));

        if (!this.isSSO) {
          const params = {
            setting: {
              language: value,
            },
          };
          await this.$store.dispatch('postUserSettings', params);
        }

        changeLanguage(value);

        // Save to Cookie
        Cookies.set('mo-wave-locale', value, {
          expires: 365,
        });

        // After Request
        await this.$alpha.loading.hide(1000);
        await this.$alpha.notify.success('change', this.$t('Language'));
      } catch (e) {
        await this.$alpha.notify.error('change', this.$t('Language'));
      }
    },
  },
});
</script>
